import { render, staticRenderFns } from "./WraparoundLayout.vue?vue&type=template&id=f90fe84a&scoped=true&"
import script from "./WraparoundLayout.vue?vue&type=script&lang=js&"
export * from "./WraparoundLayout.vue?vue&type=script&lang=js&"
import style0 from "./WraparoundLayout.vue?vue&type=style&index=0&id=f90fe84a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f90fe84a",
  null
  
)

export default component.exports